import styled from 'styled-components';
import React from 'react';
import PropTypes, { array } from 'prop-types';
import { Header, List } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { ModuleContainer } from '../../components';
import { Breakpoints, Formatters } from '../../utils';
import { announcementsBG } from '../../images';
import { Routes } from '../../routing';
import { withAnalytics } from '../../analytics';
import { colors, verticalGutter } from '../../styles';
import { useMediaQuery } from 'react-responsive';

const Announcements = ({ data: announcements, analytics }) => {
  const StyledAnnouncements = styled.div`
    position: relative;
    height: 100%;
    &,
    * {
      color: #fff !important;
    }

    &:before {
      content: '';
      background: ${colors.primary} url(${announcementsBG}) no-repeat center
        center;
      background-size: cover;
      display: block;
      width: calc(101% + ${verticalGutter * 2}rem);
      height: calc(101% + ${verticalGutter * 2}rem);
      position: absolute;
      top: ${verticalGutter * -1}rem;
      left: ${verticalGutter * -1}rem;
      z-index: 0;
    }

    > * {
      position: relative;
      z-index: 1;
    }

    /* namespace'd styles */
    .announcements {
      &__title {
        display: block;
      }
      /* make scroll bars for overflown content */
      &__scroll {
        overflow-y: auto;
        @media only screen and (min-width: ${Breakpoints.computerBreakpoint}px) {
          padding-bottom: calc(100% - ${verticalGutter * 3}rem);
          margin-bottom: -${verticalGutter}rem;
          > .ui.list {
            position: absolute;
            width: 100%;
            top: 0;
          }
        }
        @media only screen and (min-width: ${Breakpoints.largeMonitorBreakpoint}px) {
          padding-bottom: calc(100% - ${verticalGutter * 4}rem);
        }

        @media only screen and (min-width: ${Breakpoints.widescreenMonitorBreakpoint}px) {
          /* random from JustLaunched component */
          padding-bottom: calc(${(20 / 43) * 100}% - ${verticalGutter * 2}rem);
        }
      }
    }
  `;
  const isWidescreen = useMediaQuery({
    minWidth: Breakpoints.widescreenMonitorBreakpoint
  });

  const renderItem = announcement => (
    <List.Item as="article" key={announcement.id}>
      <List.Description
        as="time"
        dateTime={Formatters.date(announcement.createdAt, 'YYYY-MM-DD')}
      >
        {Formatters.date(announcement.createdAt, 'MMMM Do')}
      </List.Description>
      <strong>
        <Link
          to={`${Routes.announcement}/${announcement.id}`}
          onClick={() =>
            analytics.trackEvent('Announcements Panel Click', {
              url: `${Routes.announcement}/${announcement.id}`,
              title: announcement.title
            })
          }
          className="announcements__title"
        >
          {announcement.title}
        </Link>
      </strong>
      {announcement.teaser && isWidescreen && <p>{announcement.teaser}</p>}
    </List.Item>
  );

  return (
    <ModuleContainer>
      <StyledAnnouncements>
        <Header as="h3" className="text--header">
          Announcements
        </Header>

        <section className="announcements__scroll">
          <List divided inverted>
            {announcements.slice(0, 4).map(renderItem)}
          </List>
        </section>
      </StyledAnnouncements>
    </ModuleContainer>
  );
};

Announcements.propTypes = {
  data: array,
  analytics: PropTypes.object
};

export default withAnalytics(Announcements);
